import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz';

// Frontend mirror of Nexceo::FollowUps::MeetingSlots (app/services/nexceo/follow_ups/
// meeting_slots.rb). The backend is the authority - it re-validates every write - this exists so
// the UI never offers a time the backend would reject. Both sides have a spec pinning the exact
// same 25 values, so they cannot drift apart silently.
export const FOLLOW_UP_TYPES = {
  ONLINE_MEETING: 'online_meeting',
  OPEN_FOLLOW_UP: 'open_follow_up',
  PHYSICAL_MEETING: 'physical_meeting',
};

export const FOLLOW_UP_TYPE_LIST = [
  FOLLOW_UP_TYPES.ONLINE_MEETING,
  FOLLOW_UP_TYPES.OPEN_FOLLOW_UP,
  FOLLOW_UP_TYPES.PHYSICAL_MEETING,
];

const pad = num => String(num).padStart(2, '0');

// 09:00 through 21:00 inclusive, 30-minute steps: 25 start times. 21:00 is a valid START time;
// whether the provider actually has that slot free is still the provider's call.
export const MEETING_SLOTS = Array.from({ length: 25 }, (_, index) => {
  const minutes = (18 + index) * 30;
  return `${pad(Math.floor(minutes / 60))}:${pad(minutes % 60)}`;
});

// Same fallback as the backend (Nexceo::FollowUps::MeetingSlots::DEFAULT_TIMEZONE).
export const DEFAULT_BUSINESS_TIMEZONE = 'Asia/Kolkata';

export const isMeetingType = type =>
  type === FOLLOW_UP_TYPES.ONLINE_MEETING ||
  type === FOLLOW_UP_TYPES.PHYSICAL_MEETING;

export const isValidMeetingSlot = time => MEETING_SLOTS.includes(time);

// Rows saved before follow-up types existed have no type: a meeting when meeting_required was
// set, otherwise an open follow-up (mirrors Nexceo::FollowUps::Snapshot#type).
export const resolveFollowUpType = ({ followUpType, meetingRequired }) => {
  if (FOLLOW_UP_TYPE_LIST.includes(followUpType)) return followUpType;
  return meetingRequired
    ? FOLLOW_UP_TYPES.ONLINE_MEETING
    : FOLLOW_UP_TYPES.OPEN_FOLLOW_UP;
};

// "2026-10-05" + "15:30" as wall-clock time in `timeZone` -> an absolute ISO instant. Meeting
// slots are business-time slots, so the browser's own timezone must never leak into them.
export const zonedDateTimeToIso = (
  dateStr,
  timeStr,
  timeZone = DEFAULT_BUSINESS_TIMEZONE
) => {
  if (!dateStr) return '';
  return zonedTimeToUtc(
    `${dateStr}T${timeStr || '00:00'}:00`,
    timeZone
  ).toISOString();
};

// The inverse: an absolute instant -> the date/time inputs' wall-clock strings in `timeZone`.
export const isoToZonedParts = (iso, timeZone = DEFAULT_BUSINESS_TIMEZONE) => {
  if (!iso) return { date: '', time: '' };
  const instant = new Date(iso);
  if (Number.isNaN(instant.getTime())) return { date: '', time: '' };
  return {
    date: formatInTimeZone(instant, timeZone, 'yyyy-MM-dd'),
    time: formatInTimeZone(instant, timeZone, 'HH:mm'),
  };
};
